/** Floating badge above the character whose POV we are following. */
export function TimelinePovIndicatorLayer() {
  return (
    <div className="timeline-marker-layer timeline-marker-layer--pov" aria-hidden="true">
      <div data-pov-indicator className="timeline-pov-indicator">
        <span className="timeline-pov-indicator__glyph" aria-hidden="true" />
        <span className="timeline-pov-indicator__label">POV</span>
      </div>
    </div>
  );
}
